import React from 'react';
import { render } from '@testing-library/react';
import { ButtonToggle } from './ButtonToggle';

describe('ButtonToggle', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<ButtonToggle
				value={2}
				small
				options={[
					{ text: '1', value: 1 },
					{ text: '2', value: 2 },
				]}
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
